import { h } from 'preact';
import { canUser } from 'utils/roles';

import WatchPageEditor from 'components/editor/movies/watch/watch';
import MediaField from 'components/editor/settings/mediaField';
import ToggleField from 'components/editor/settings/toggleField';

// Styling imports will only happen in the final styling file used (i.e. homeEntUniversal.sss or showtimesUniversal.sss)
// import s from 'components/editor/movies/watch/watchUniversal.sss';

export default class UniversalWatchPageEditor extends WatchPageEditor {
	s = {}; // Styling will only be assigned in the final implementation (i.e. homeEntUniversal.js or showtimesUniversal.js)

	renderMobileHeaderImageSettings() {
		const readonly = !canUser('write');
		const useCustomHeader = this.getData().headerImage?.custom;
		const root = `${this.props.dataRoot}/content/pages/${this.type}/headerImage`;
		const mediaPath = useCustomHeader ? `${root}/url` : `${this.props.dataRoot}/content/headerImage/url`;
	
		return (
			<div class={this.s.mediaField}>
				<h4>Header image (Mobile)</h4>
				<ToggleField dark path={`${root}/custom`} disabled={readonly}>Use unique header image</ToggleField>
				<MediaField
					dark
					label="Replace image"
					path={mediaPath}
					group={this.props.config?.id}
					assetData={{ type: 'Header', aspectRatio: '4:3', recommendedDimensions: '1400:1050' }}
					disabled={readonly || !useCustomHeader}
				/>
			</div>
		);
	}

	renderMediaSettings() {
		return [
			this.renderOnesheetSettings(),
			this.renderMobileHeaderImageSettings()
		];
	}
}
